/**
 * Guard de sesión para pantallas públicas que sí requieren estar autenticado.
 *
 * `/change-password` es una pantalla de acceso (fuera del shell) pero sin ella
 * no tiene sentido: sin sesión no hay credencial que cambiar. Registrarla como
 * ruta pública sin más mostraba un formulario aparentemente válido a un
 * visitante anónimo, que solo se enteraba del problema al enviar y recibía un
 * 401.
 *
 * A diferencia de `ProtectedRoute`, no exige contexto de tenant ni permiso: lo
 * único que necesita es una sesión.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingSpinner } from '@/components/shared/feedback/Feedback';
import type { ReactNode } from 'react';

type RequireSessionProps = { children: ReactNode };

export function RequireSession({ children }: RequireSessionProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingSpinner size="lg" />;
  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;

  return <>{children}</>;
}
